<template>
  <div class="intro">
    <h1 class="info">{{ msg }}</h1>
    <p class="info">
      Thank You Enjoy My Game. If You Have Any Idea Or Problem. You Can Connect
      me.
    </p>
    <h2 class="info">privacy policy</h2>
    <ul>
      <li>
        <a
          class="info"
          @click="$router.push('/privacypolicy/Application')"
          target="_self"
          rel="noopener"
          >English</a
        >
      </li>
      <li>
        <a
          class="info"
          @click="$router.push('/privacypolicycn/Application')"
          target="_self"
          rel="noopener"
          >中文</a
        >
      </li>
      <br />
    </ul>
    <h2 class="info">contact</h2>
    <ul>
      <li>
        <a
          class="info"
          href="mailto:zszen@hotmail.com"
          target="_blank"
          rel="noopener"
          >Email: zszen@hotmail.com</a
        >
      </li>
      <br />
      <li>
        <a
          class="info"
          href="https://twitter.com/zszen"
          target="_blank"
          rel="noopener"
          >Twitter: zszen</a
        >
      </li>
      <br />
      <li>
        <a
          class="info"
          href="https://github.com/zszen"
          target="_blank"
          rel="noopener"
          >Github: zszen</a
        >
      </li>
      <br />
      <li>
        <a
          class="info"
          href="https://www.jianshu.com/u/15893823363f"
          target="_blank"
          rel="noopener"
          >简书: zszen</a
        >
      </li>
    </ul>
    <h2 class="info">photographer</h2>
    <ul>
      <li>
        <a
          class="info"
          href="https://www.pexels.com/@zszen"
          target="_blank"
          rel="noopener"
          >Pexels: zszen</a
        >
      </li>
      <li>
        <a
          class="info"
          href="https://www.flickr.com/photos/zszen/"
          target="_blank"
          rel="noopener"
          >Flickr: zszen</a
        >
      </li>
    </ul>
    <h2 class="info">interest</h2>
    <ul>
      <li>
        <a v-for="unit in interest" :key="unit" herf="#">{{ unit }}, </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Intro",
  props: {
    msg: String
  },
  data() {
    return {
      interest: [
        "Snowboard",
        "Bike Rider",
        "Runner",
        "Swim",
        "Cameraman",
        "Video Post",
        "Photography",
        "STM/MCU dev",
        "Front-End Developer"
      ]
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.info {
  color: #ffffff;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
